import { render, staticRenderFns } from "./rankingProgressBar.vue?vue&type=template&id=4b54e250&scoped=true&"
import script from "./rankingProgressBar.vue?vue&type=script&lang=js&"
export * from "./rankingProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./rankingProgressBar.vue?vue&type=style&index=0&id=4b54e250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b54e250",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
